<router-outlet></router-outlet>

<ngx-spinner type="ball-newton-cradle" [fullScreen]="true" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff">
  {{ (mensagemSpinner$ | async) || 'Carregando...' }}
</ngx-spinner>
